// ChatbotHeader.jsx
import React from 'react';
import PropTypes          from 'prop-types';
import MicIcon            from '@mui/icons-material/Mic';
import MicOffIcon from '@mui/icons-material/MicOff';
import ExpandMoreIcon     from '@mui/icons-material/ExpandMore';
import d_icon             from './doc_d.png';
import { useMicCapability } from './useMicCapability';
import { IconButton, Tooltip } from '@mui/material'; 

const ChatbotHeader = ({ onClose, onAudioConversation, onShowMicDialog, keyboardOnly = false, audioActive = false}) => {
  /* local toggle purely for the look of the button */
  
  const { state: micState } = useMicCapability();

  const isReady       = micState === 'ready';
  const isBlocked     = micState === 'blocked';
  const needsPrompt   = micState === 'needs-prompt';
  const noDevice      = micState === 'no-device';

  // DISABLE only when the mic is impossible to use (blocked/no device).
const buttonDisabled = keyboardOnly || isBlocked || noDevice;


const openReasonedDialog = () => {
  if (keyboardOnly) { onShowMicDialog?.('user-disabled'); return; }
  if (isBlocked)     { onShowMicDialog?.('blocked'); return; }
  if (noDevice)      { onShowMicDialog?.('no-device'); return; }
  if (needsPrompt)   { onShowMicDialog?.('prompt'); return; }
};

// authoritative icon state comes from props
const audioOn = !!audioActive;

const handleMicClick = () => {
  if (buttonDisabled) { openReasonedDialog(); return; }
  if (!isReady)       { openReasonedDialog(); return; }
  onAudioConversation?.(!audioOn); // request desired state
};



const title =
keyboardOnly ? 'Keyboard mode (microphone disabled)' :
(noDevice   && 'No microphone detected. Using keyboard.') ||
(isBlocked  && 'Microphone access is blocked in browser/site settings.') ||
(needsPrompt && 'Click to set up microphone access.') ||
(isReady    && (audioOn ? 'Microphone on' : 'Microphone off')) ||
'Microphone';

  return (
    <div
      className='chatbox-header-draggable'
      style={{
        display            : 'flex',
        justifyContent     : 'space-between',
        alignItems         : 'center',
        padding            : '8px 16px',
        background         : '#02A887',
        color              : 'white',
        borderBottom       : '1px solid #e0e0e0',
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        zIndex: 10,
      }}
    >
      <img src={d_icon} width={30} height={30} alt='Doctivity logo' />

      <span style={{ width: '80%', textAlign: 'left', paddingLeft: 15 }}>
        Doctivity AI Assistant
      </span>

      {/* microphone toggle */}
      <Tooltip title={title}
      slotProps={{ popper: { sx: { zIndex: 10050 } } }}  // higher than chat
      PopperProps={{ disablePortal: false }}
      >
        <span onClick={openReasonedDialog} style={{ display:'inline-flex', cursor: buttonDisabled ? 'not-allowed' : 'pointer' }}>
            <IconButton
              size='medium'
              onClick={handleMicClick}
              disabled={buttonDisabled}
                sx={{
              p            : 0.8,
              borderRadius : '50%',
              bgcolor      : audioOn ? '#fff' : 'transparent',
              '&:hover'    : {
                bgcolor    : audioOn ? '#fff' : 'rgba(255,255,255,0.15)',
                cursor: buttonDisabled ? 'not-allowed' : 'pointer',
              },
            }}
          >

            {buttonDisabled ? (
              <MicOffIcon sx={{ width:25, height:25, color:'#fff', opacity:0.8 }} />
            ) : (
              <MicIcon sx={{ width:25, height:25, color: audioOn ? '#02A887' : '#fff' }} />
            )}
          </IconButton>
        </span>
      </Tooltip>
      {/* collapse / minimise */}
      <ExpandMoreIcon
        onClick={onClose}
        sx={{ cursor:'pointer', color:'#fff', width:35, height:35 }}
      />
    </div>
  );
};

ChatbotHeader.propTypes = {
  onClose            : PropTypes.func.isRequired,
  onAudioConversation: PropTypes.func.isRequired, // receives true / false
  onShowMicDialog    : PropTypes.func,            // show “Microphone Access” dialog
  keyboardOnly      : PropTypes.bool,                // optional: disable mic button
  audioActive: PropTypes.bool
};

export default ChatbotHeader;